<template>
  <div class="animate-pulse">
    <!-- Header skeleton -->
    <div class="flex justify-between items-center mb-4">
      <div class="h-6 bg-gray-200 rounded w-1/4"></div>
      <div class="h-8 bg-gray-200 rounded w-32"></div>
    </div>

    <!-- Statistics cards skeleton -->
    <div class="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
      <div class="bg-white p-4 rounded shadow">
        <div class="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
        <div class="h-8 bg-gray-200 rounded w-1/2 mb-2"></div>
        <div class="h-3 bg-gray-200 rounded w-2/3"></div>
      </div>
      <div class="bg-white p-4 rounded shadow">
        <div class="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
        <div class="h-8 bg-gray-200 rounded w-1/2 mb-2"></div>
        <div class="h-3 bg-gray-200 rounded w-2/3"></div>
      </div>
      <div class="bg-white p-4 rounded shadow">
        <div class="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
        <div class="h-8 bg-gray-200 rounded w-1/2 mb-2"></div>
        <div class="h-3 bg-gray-200 rounded w-2/3"></div>
      </div>
    </div>

    <!-- Table skeleton -->
    <div class="bg-white shadow-md overflow-hidden">
      <!-- Table header -->
      <div class="bg-gray-100 border-b">
        <div class="grid grid-cols-10 gap-4 py-2 px-3">
          <div class="h-4 bg-gray-200 rounded"></div>
          <div class="h-4 bg-gray-200 rounded"></div>
          <div class="h-4 bg-gray-200 rounded"></div>
          <div class="h-4 bg-gray-200 rounded"></div>
          <div class="h-4 bg-gray-200 rounded"></div>
          <div class="h-4 bg-gray-200 rounded"></div>
          <div class="h-4 bg-gray-200 rounded"></div>
          <div class="h-4 bg-gray-200 rounded"></div>
          <div class="h-4 bg-gray-200 rounded"></div>
          <div class="h-4 bg-gray-200 rounded"></div>
        </div>
      </div>
      
      <!-- Table rows -->
      <div class="divide-y divide-gray-200">
        <div v-for="i in 5" :key="i" class="grid grid-cols-10 gap-4 py-4 px-3">
          <div class="h-4 bg-gray-200 rounded"></div>
          <div class="h-4 bg-gray-200 rounded"></div>
          <div class="h-4 bg-gray-200 rounded"></div>
          <div class="h-4 bg-gray-200 rounded"></div>
          <div class="h-4 bg-gray-200 rounded"></div>
          <div class="h-4 bg-gray-200 rounded"></div>
          <div class="h-4 bg-gray-200 rounded"></div>
          <div class="h-4 bg-gray-200 rounded"></div>
          <div class="h-4 bg-gray-200 rounded"></div>
          <div class="h-4 bg-gray-200 rounded"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SkeletonCpdTokenTabLoader'
}
</script>